import { render } from "./PreviewGiftingModal.vue?vue&type=template&id=2a822eb8&scoped=true"
import script from "./PreviewGiftingModal.vue?vue&type=script&lang=js"
export * from "./PreviewGiftingModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/giftNftModal.scss?vue&type=style&index=0&id=2a822eb8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a822eb8"]])

export default __exports__